import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import * as Types from '../actions/constants';

const INITIAL_STATE = fromJS({
  records: {
    loading: false,
    filters: {
      text: '',
      roles: ['operator', 'supervisor', 'admin', 'inquirer']
    },
    data: [],
    selected: null,
    limit: 5,
    skip: 0,
    total: 0,
    error: null
  },
  upsertModal: false,
  filtersModal: false,
  form: {
    submitting: false,
    error: null,
    values: {
      id: null,
      email: '',
      name: '',
      password: '',
      clearance: 0,
      roles: []
    }
  }
});

const usersReducer = handleActions({
  [Types.FIND_USERS_ATTEMPT]: (state, action) => state.mergeIn(['records'], {
    loading: true, error: null,
    filters: action.payload.filters,
    limit: action.payload.limit,
    skip: action.payload.skip
  }),
  [Types.FIND_USERS_SUCCESS]: (state, action) => state.mergeIn(['records'], {
    loading: false,
    data: action.payload.data,
    limit: action.payload.limit,
    skip: action.payload.skip,
    total: action.payload.total
  }),
  [Types.FIND_USERS_FAILURE]: (state, action) => state.mergeIn(['records'], { loading: false, error: action.payload }),
  [Types.REMOVE_USER_ATTEMPT]: (state, action) => state.mergeIn(['records'], { loading: true, error: null }),
  [Types.REMOVE_USER_SUCCESS]: (state, action) => state.mergeIn(['records'], {
    loading: false,
    data: state.getIn(['records', 'data']).filter(user => {
      return user.get('id') !== action.payload.id;
    })
  }),
  [Types.REMOVE_USER_FAILURE]: (state, action) => state.mergeIn(['records'], { loading: false, error: action.payload.error }),
  [Types.CHANGE_USER_FORM_VALUE]: (state, action) => state.mergeIn(['form', 'values'], {
    [action.payload.name]: action.payload.value
  }),
  [Types.RESET_USER_FORM]: (state, action) => state.mergeIn(['form'], INITIAL_STATE.get('form')),
  [Types.FILL_USER_FORM]: (state, action) => state.mergeIn(['form', 'values'], { ...action.payload.values }),
  [Types.TOGGLE_USER_UPSERT_MODAL]: (state, action) => state.merge({ upsertModal: !state.get('upsertModal') }),
  [Types.TOGGLE_USER_FILTERS_MODAL]: (state, action) => state.merge({ filtersModal: !state.get('filtersModal') }),
  [Types.SET_USERS_FILTER]: (state, action) => state.mergeIn(['records', 'filters'], {
    [action.payload.name]: action.payload.value
  }),
  [Types.SELECT_USER]: (state, action) => state.mergeIn(['records'], { selected: action.payload.user }),
  [Types.UPSERT_USER_ATTEMPT]: (state, action) => state.mergeIn(['form'], {
    submitting: true
  }),
  [Types.UPSERT_USER_SUCCESS]: (state, action) => {
    let itemExists = state.getIn(['records', 'data']).some(user => user.get('id') === action.payload.user.id);

    if (itemExists) {
      return state.merge({
        form: state.get('form').merge({ submitting: false }),
        records: state.get('records').merge({
          data: state.getIn(['records', 'data']).map(user => {
            if (user.get('id') === action.payload.user.id) {
              return fromJS(action.payload.user);
            } else {
              return user;
            }
          })
        })
      });
    } else {
      return state.merge({
        form: state.get('form').merge({ submitting: false }),
        records: state.get('records').merge({
          data: state.getIn(['records', 'data']).push(fromJS(action.payload.user))
        })
      });
    }
  },
  [Types.UPSERT_USER_FAILURE]: (state, action) => state.mergeIn(['form'], {
    submitting: false,
    error: action.payload
  })
}, INITIAL_STATE);


export default usersReducer;



// WEBPACK FOOTER //
// ./client/store/reducers/usersReducer.js